import { climate2050, trendLabel, futureProofScore, ZWOLLE_BASELINE } from "../lib/climate2050.js";

export function Climate2050Card({ concelho }) {
  if (!concelho?.slug) return null;
  const proj = climate2050(concelho.slug);
  if (!proj) return null;
  const cur = concelho.climate || {};
  const trend = trendLabel(proj.trend);
  const score = futureProofScore(cur, proj);

  const Row = ({ label, now, future, zwolleNow, zwolleFuture, unit, betterIfLower = true, emoji }) => {
    const delta = future - now;
    const arrow = Math.abs(delta) < 0.5 ? "→" : (delta > 0 ? "↗" : "↘");
    const color = betterIfLower
      ? (delta < 0 ? "#3d6e48" : delta > 0 ? "#b85c4d" : "#5b6573")
      : (delta > 0 ? "#3d6e48" : delta < 0 ? "#b85c4d" : "#5b6573");
    return (
      <div className="c50-row">
        <span className="c50-row-label">{emoji} {label}</span>
        <div className="c50-row-cols">
          <div className="c50-cell c50-cell-pt">
            <span className="c50-now">{now}{unit}</span>
            <span className="c50-arrow" style={{ color }}>{arrow}</span>
            <span className="c50-future" style={{ color }}>{future}{unit}</span>
          </div>
          <div className="c50-cell c50-cell-zwolle">
            <span className="c50-zw-now">{zwolleNow}{unit}</span>
            <span className="c50-arrow c50-zw-arrow">→</span>
            <span className="c50-zw-future">{zwolleFuture}{unit}</span>
          </div>
        </div>
      </div>
    );
  };

  const zwNow = ZWOLLE_BASELINE.current;
  const zwFuture = ZWOLLE_BASELINE.projected_2050;

  return (
    <section className="c50-card" data-trend={proj.trend}>
      <header className="c50-head">
        <h3>Klimaat-projectie 2050</h3>
        <div className="c50-trend">
          <span className="c50-trend-emoji">{trend.emoji}</span>
          <span className="c50-trend-label">{trend.label}</span>
        </div>
      </header>
      <p className="c50-note">{trend.note}</p>

      <div className="c50-header-row">
        <span className="c50-header-label"></span>
        <div className="c50-header-cols">
          <span className="c50-header-pt">Hier (nu → 2050)</span>
          <span className="c50-header-zw">Zwolle (nu → 2050)</span>
        </div>
      </div>

      <div className="c50-grid">
        {cur.heat_days_35 != null && (
          <Row
            label="Hittedagen >35°C/jr"
            now={cur.heat_days_35}
            future={proj.heat_days_35}
            zwolleNow={zwNow.heat_days_35}
            zwolleFuture={zwFuture.heat_days_35}
            unit=" dgn"
            emoji="🔥"
          />
        )}
        {cur.summer_max_p95 != null && (
          <Row
            label="Zomerpiek (p95)"
            now={cur.summer_max_p95}
            future={proj.summer_max_p95}
            zwolleNow={zwNow.summer_max_p95}
            zwolleFuture={zwFuture.summer_max_p95}
            unit="°C"
            emoji="☀"
          />
        )}
        {cur.annual_rainfall_mm != null && (
          <Row
            label="Jaarlijkse regen"
            now={cur.annual_rainfall_mm}
            future={proj.annual_rainfall_mm}
            zwolleNow={zwNow.annual_rainfall_mm}
            zwolleFuture={zwFuture.annual_rainfall_mm}
            unit=" mm"
            betterIfLower={false}
            emoji="🌧"
          />
        )}
        {cur.annual_sunshine_h != null && proj.annual_sunshine_h != null && (
          <Row
            label="Jaarlijkse zonneuren"
            now={cur.annual_sunshine_h}
            future={proj.annual_sunshine_h}
            zwolleNow={zwNow.annual_sunshine_h}
            zwolleFuture={zwFuture.annual_sunshine_h}
            unit=" h"
            betterIfLower={false}
            emoji="🌞"
          />
        )}
      </div>

      {score != null && (
        <div className="c50-score">
          <span className="c50-score-label">Future-proof score</span>
          <span className="c50-score-num">{score}<small>/5</small></span>
          <div className="c50-score-dots">
            {[1,2,3,4,5].map(i => (
              <span key={i} className={`c50-dot ${i <= score ? "filled" : ""}`} />
            ))}
          </div>
        </div>
      )}

      <small className="c50-source">
        Basis: IPCC SSP2-4.5 + EURO-CORDEX (PT) en KNMI'23 (Zwolle).
        Onzekerheid ±30%, toont richting en grootte-orde.
      </small>
    </section>
  );
}
